module.exports = __webpack_public_path__ + "static/media/12345.c14eb230.svg";